module.exports = __webpack_public_path__ + "img/background_texture.0c232ba8.png";